import React from 'react'
import ButtonLink from '../ButtonLink'

type TemplateDownloaderProps = {
	text: string
	url: string
}
export default function TemplateDownloader({ text, url }: TemplateDownloaderProps): React.ReactNode {
	return (
		<ButtonLink iconName='download'>
			<a href={url} target='_blank' rel='noreferrer'>
				{text}
			</a>
		</ButtonLink>
	)
}
